import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class GlobalService {
	sidebarActive$: Observable<boolean>;
	spinnerActive$: Observable<boolean>;
	refreshButtonActive$: Observable<boolean>;

	private sidebarActive: boolean;
	private sidebarActiveSource = new BehaviorSubject<boolean>(true);

	private spinnerActive: boolean;
	private spinnerActiveSource = new Subject<boolean>();

	private refreshButtonActiveSource = new BehaviorSubject<boolean>(true);

	constructor(private http: HttpClient) {
		this.sidebarActive$ = this.sidebarActiveSource.asObservable();
		this.spinnerActive$ = this.spinnerActiveSource.asObservable();
		this.refreshButtonActive$ = this.refreshButtonActiveSource.asObservable();
	}

	toggleSidebar(): void {
		this.sidebarActive = !this.sidebarActive;
		this.sidebarActiveSource.next(this.sidebarActive);
	}

	closeSideBar(): void {
		this.sidebarActiveSource.next(true);
	}

	openSideBar(): void {
		this.sidebarActiveSource.next(false);
	}

	toggleSpinner(): void {
		this.spinnerActive = !this.spinnerActive;
		this.spinnerActiveSource.next(this.spinnerActive);

		if (this.spinnerActive)
			setTimeout(() => {
				this.spinnerActive = false;
				this.spinnerActiveSource.next(this.spinnerActive);
			}, 5000);
	}

	showSpinner(): void {
		this.spinnerActive = true;
		this.spinnerActiveSource.next(this.spinnerActive);
	}

	hideSpinner(): void {
		this.spinnerActive = false;
		this.spinnerActiveSource.next(this.spinnerActive);
	}

	enableRefreshButton(lastRefreshTime,remainigTime): void {
		console.log("lasad")
		
		this.refreshButtonActiveSource.next(true);
		setTimeout(() => {
			this.refreshButtonActiveSource.next(false);
		}, 300000 - remainigTime)
	}



}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/services/global.service.ts